import { render } from "./ColegioDropdown.vue?vue&type=template&id=371e2f52&scoped=true"
import script from "./ColegioDropdown.vue?vue&type=script&lang=js"
export * from "./ColegioDropdown.vue?vue&type=script&lang=js"

import "./ColegioDropdown.vue?vue&type=style&index=0&id=371e2f52&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-371e2f52"]])

export default __exports__